<template>
	<div class="SocialmediaCronReportsList">

		<template v-if="isLoading">
			<div class="text-xs-center pa-5">
				<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
				<div class="caption mt-4">Listeleniyor</div>
			</div>
		</template>
		<template v-if="!isLoading"> 
			<div class="text-xs-center mb-4 mt-2">
				<v-btn round color="teal" outline  @click="loadItems()">Listeyi Yenile</v-btn>
			</div>
		</template>

		<div class="reportItems">
			<div class="reportItem" v-for="(item,itemIndex) in items" :key="itemIndex" :reporttype="item.reporttype">
				<div class="text"><span class="date">{{item.date}}</span> {{item.text}}</div>
			</div>
		</div>

	</div>
</template>


<script>
	export default {
		name: "SocialmediaCronReportsList",
		data: () => ({
			isLoading: true,
			items: []
		}),
		mounted() {
			this.loadItems()
		},
		methods: {
			loadItems() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cron/reports/", {
					params: {}
				}).then(response => {
					this.items = response.body;
					this.isLoading = false;
				})
			}
		}
	}
</script>


<style lang="less">
	.SocialmediaCronReportsList {
		padding: 15px;

		.reportItems {
			.reportItem {
				font-family: consolas;
				background-color: #eee;
				border: 1px solid #ccc;
				padding: 10px;
				margin-bottom: 5px;

				.date {
					font-weight: 700;
					color: rgb(0, 86, 247)
				}

				&[reporttype="success"] {
					background-color: rgb(182, 250, 156);
					border: 1px solid rgb(98, 230, 47);
				}

				&[reporttype="error"] {
					background-color: rgb(255, 193, 193);
					border: 1px solid rgb(255, 113, 113);
				}
			}
		}
	}
</style>